import useSlugExtractor from "@hooks/useSlugExtractor"

import { AccessCheck } from "@particles/index"

import { TopBar } from "@organisms"
import ViewTypesProvider from "@organisms/ObjectsView/ViewTypesProvider/ViewTypesProvider"

import { AppFrame } from "@templates"

import { CREDIT_NOTES_ROUTES } from "@routes/creditNotes"

import { objectMap } from "@constants/objectMap"
import { PERMISSION_LEVEL } from "@constants/permissionLevel"
import { CREDIT_NOTES_LIST_CONTROLS_VIEW } from "@constants/storage"

import CreditNoteTableView from "./views/CreditNoteTableView/CreditNoteTableView"

export default function CreditNoteList() {
    const [createRoute] = useSlugExtractor([CREDIT_NOTES_ROUTES.CREATE])

    return (
        <AppFrame.Root collaborationRoomName="credit-note-list">
            <ViewTypesProvider viewTypeKey={CREDIT_NOTES_LIST_CONTROLS_VIEW} defaultViewType={"table"}>
                {({ activeViewType }) => (
                    <>
                        <TopBar.Root>
                            <TopBar.Header>
                                <TopBar.TopBarHeaderStart>
                                    <TopBar.PageTitle
                                        label={objectMap.credit_note.labelPlural}
                                        icon={objectMap.credit_note.iconActive}
                                    />
                                </TopBar.TopBarHeaderStart>
                                <TopBar.TopBarHeaderEnd>
                                    <TopBar.PagePresence />
                                    <AccessCheck
                                        permissions={{
                                            invoices_list_permission: PERMISSION_LEVEL.RESTRICTED,
                                        }}
                                    >
                                        <AccessCheck
                                            permissions={{
                                                invoices_view_permission: PERMISSION_LEVEL.FULL,
                                            }}
                                        >
                                            <TopBar.SearchButton scope="Credit Notes" />
                                        </AccessCheck>
                                    </AccessCheck>
                                    <TopBar.ViewSelector viewTypes={["table"]} />
                                    <AccessCheck
                                        permissions={{
                                            invoices_create_permission: PERMISSION_LEVEL.RESTRICTED,
                                        }}
                                    >
                                        <TopBar.CTAButton destination={createRoute} />
                                    </AccessCheck>
                                </TopBar.TopBarHeaderEnd>
                            </TopBar.Header>
                        </TopBar.Root>
                        {activeViewType === "table" ? <CreditNoteTableView /> : <CreditNoteTableView />}
                    </>
                )}
            </ViewTypesProvider>
        </AppFrame.Root>
    )
}
